/* eslint-disable no-useless-escape */
const componentCodeBack = () => [
  {
    code: `
    import { MercadoPagoConfig, Payment } from 'mercadopago';

    const client = new MercadoPagoConfig({ accessToken: 'YOUR_ACCESS_TOKEN' });
    
    const payment = new Payment(client);
    payment.create({ body: req.body })
    .then(console.log)
    .catch(console.log);
    `,
    type: 'javascript',
    extension: 'js',
    value: 'node',
    payment: 'card',
    name: 'Node.js',
  },
  {
    code: `
    import { MercadoPagoConfig, Payment } from 'mercadopago';

    const client = new MercadoPagoConfig({ accessToken: 'YOUR_ACCESS_TOKEN' });

    const payment = new Payment(client);
    payment.create({ body: req.body })
    .then(console.log)
    .catch(console.log);
    `,
    type: 'javascript',
    extension: 'js',
    value: 'node',
    payment: 'bankTransfer',
    name: 'Node.js',
  },
  {
    code: `
    import { MercadoPagoConfig, Payment } from 'mercadopago';

    const client = new MercadoPagoConfig({ accessToken: 'YOUR_ACCESS_TOKEN' });
    
    const payment = new Payment(client);
    payment.create({ body: req.body })
    .then(console.log)
    .catch(console.log);
    `,
    type: 'javascript',
    extension: 'js',
    value: 'node',
    payment: 'ticket',
    name: 'Node.js',
  },
  {
    code: `
    <?php
      use MercadoPago\\Client\\Payment\\PaymentClient;
      use MercadoPago\\MercadoPagoConfig;


      MercadoPagoConfig::setAccessToken("YOUR_ACCESS_TOKEN");

      $client = new PaymentClient();
      $request_options = new MPRequestOptions();
      $request_options->setCustomHeaders(["X-Idempotency-Key: <SOME_UNIQUE_VALUE>"]);

      $payment = $client->create([
        "token" => $_POST['token'],
        "issuer_id" => $_POST['issuer_id'],
        "payment_method_id" => $_POST['paymentMethodId'],
        "transaction_amount" => (float) $_POST['transactionAmount'],
        "installments" => $_POST['installments'],
        "payer" => [
          "email" => $_POST['email'],
          "identification" => [
            "type" => $_POST['identificationType'],
            "number" => $_POST['number']
          ]
        ]
      ], $request_options);
      echo implode($payment);
    ?>
    `,
    type: 'php',
    extension: 'php',
    value: 'php',
    payment: 'card',
    name: 'PHP',
  },
  {
    code: `
    <?php
      use MercadoPago\Client\Payment\PaymentClient;
      use MercadoPago\MercadoPagoConfig;
    
    
      MercadoPagoConfig::setAccessToken("YOUR_ACCESS_TOKEN");
    
      $client = new PaymentClient();
      $request_options = new MPRequestOptions();
      $request_options->setCustomHeaders(["X-Idempotency-Key: <SOME_UNIQUE_VALUE>"]);
    
      $payment = $client->create([
        "payment_method_id" => $_POST['paymentMethodId'],
        "transaction_amount" => (float) $_POST['transactionAmount'],
        "payer" => [
          "email" => $_POST['email'],
        ]
      ], $request_options);
      echo implode($payment);
    ?>  
    `,
    type: 'php',
    extension: 'php',
    value: 'php',
    payment: 'bankTransfer',
    name: 'PHP',
  },
  {
    code: `
    <?php
      use MercadoPago\Client\Payment\PaymentClient;
      use MercadoPago\MercadoPagoConfig;
    
    
      MercadoPagoConfig::setAccessToken("YOUR_ACCESS_TOKEN");
    
      $client = new PaymentClient();
      $request_options = new MPRequestOptions();
      $request_options->setCustomHeaders(["X-Idempotency-Key: <SOME_UNIQUE_VALUE>"]);
    
      $payment = $client->create([
        "payment_method_id" => $_POST['paymentMethodId'],
        "transaction_amount" => (float) $_POST['transactionAmount'],
        "payer" => [
          "email" => $_POST['email'],
        ]
      ], $request_options);
      echo implode($payment);
    ?>  
    `,
    type: 'php',
    extension: 'php',
    value: 'php',
    payment: 'ticket',
    name: 'PHP',
  },
  {
    code: `
    PaymentClient client = new PaymentClient();

    PaymentCreateRequest paymentCreateRequest =
       PaymentCreateRequest.builder()
           .transactionAmount(request.getTransactionAmount())
           .token(request.getToken())
           .description(request.getDescription())
           .installments(request.getInstallments())
           .paymentMethodId(request.getPaymentMethodId())
           .payer(
               PaymentPayerRequest.builder()
                   .email(request.getPayer().getEmail())
                   .firstName(request.getPayer().getFirstName())
                   .identification(
                       IdentificationRequest.builder()
                           .type(request.getPayer().getIdentification().getType())
                           .number(request.getPayer().getIdentification().getNumber())
                           .build())
                   .build())
           .build();

    client.create(paymentCreateRequest);
    `,
    type: 'java',
    extension: 'java',
    value: 'java',
    payment: 'card',
    name: 'Java',
  },
  {
    code: `
    MercadoPagoConfig.setAccessToken("ENV_ACCESS_TOKEN");

    PaymentClient client = new PaymentClient();

    PaymentCreateRequest paymentCreateRequest =
       PaymentCreateRequest.builder()
           .transactionAmount(new BigDecimal("100"))
           .description("Título do produto")
           .paymentMethodId("pix")
           .dateOfExpiration(OffsetDateTime.of(2023, 1, 10, 10, 10, 10, 0, ZoneOffset.UTC))
           .payer(
               PaymentPayerRequest.builder()
                   .email("test@test.com")
                   .firstName("Test")
                   .identification(
                       IdentificationRequest.builder().type("CPF").number("19119119100").build())
                   .build())
           .build();

    client.create(paymentCreateRequest);
    `,
    type: 'java',
    extension: 'java',
    value: 'java',
    payment: 'bankTransfer',
    name: 'Java',
  },
  {
    code: `
      PaymentClient client = new PaymentClient();

      PaymentCreateRequest paymentCreateRequest =
         PaymentCreateRequest.builder()
             .transactionAmount(new BigDecimal("100"))
             .description("Título do produto")
             .paymentMethodId("bolbradesco")
             .dateOfExpiration(OffsetDateTime.of(2023, 1, 10, 10, 10, 10, 0, ZoneOffset.UTC))
             .payer(
                 PaymentPayerRequest.builder()
                     .email("test@test.com")
                     .firstName("Test")
                     .lastName("User")
                     .identification(
                         IdentificationRequest.builder().type("CPF").number("19119119100").build())
                     .build())
             .build();

      client.create(paymentCreateRequest);
    `,
    type: 'java',
    extension: 'java',
    value: 'java',
    payment: 'ticket',
    name: 'Java',
  },
  {
    code: `
    require 'mercadopago'
    sdk = Mercadopago::SDK.new('YOUR_ACCESS_TOKEN')

    payment_data = {
      transaction_amount: params[:transactionAmount].to_f,
      token: params[:token],
      description: params[:description],
      installments: params[:installments].to_i,
      payment_method_id: params[:paymentMethodId],
      payer: {
        email: params[:cardholderEmail],
        identification: {
          type: params[:identificationType],
          number: params[:identificationNumber]
        },
        first_name: params[:cardholderName]
      }
    }

    payment_response = sdk.payment.create(payment_data)
    payment = payment_response[:response]

    puts payment
    `,
    type: 'ruby',
    extension: 'rb',
    value: 'ruby',
    payment: 'card',
    name: 'Ruby',
  },
  {
    code: `

    require 'mercadopago'
    sdk = Mercadopago::SDK.new('ENV_ACCESS_TOKEN')

    payment_request = {
      transaction_amount: 100,
      description: 'Título do produto',
      payment_method_id: 'pix',
      payer: {
        email: 'test@test.com',
        identification: {
          type: 'CPF',
          number: '19119119100',
        }
      }
    }

    payment_response = sdk.payment.create(payment_request)
    payment = payment_response[:response]

    `,
    type: 'ruby',
    extension: 'rb',
    value: 'ruby',
    payment: 'bankTransfer',
    name: 'Ruby',
  },
  {
    code: `
      require 'mercadopago'
      sdk = Mercadopago::SDK.new('ENV_ACCESS_TOKEN')

      payment_request = {
        transaction_amount: 100,
        description: 'Título do produto',
        payment_method_id: 'bolbradesco',
        payer: {
          email: 'test@test.com',
          first_name: 'Test',
          last_name: 'User',
          identification: {
            type: 'CPF',
            number: '19119119100',
          },
          address: {
            zip_code: '06233200',
            street_name: 'Av. das Nações Unidas',
            street_number: '3003',
            neighborhood: 'Bonfim',
            city: 'Osasco',
            federal_unit: 'SP'
          }
        }
      }

      payment_response = sdk.payment.create(payment_request)
      payment = payment_response[:response]

    `,
    type: 'ruby',
    extension: 'rb',
    value: 'ruby',
    payment: 'ticket',
    name: 'Ruby',
  },
  {
    code: `
    using System;
    using MercadoPago.Client.Common;
    using MercadoPago.Client.Payment;
    using MercadoPago.Config;
    using MercadoPago.Resource.Payment;

    MercadoPagoConfig.AccessToken = "YOUR_ACCESS_TOKEN";

    var paymentRequest = new PaymentCreateRequest
    {
        TransactionAmount = decimal.Parse(Request["transactionAmount"]),
        Token = Request["token"],
        Description = Request["description"],
        Installments = int.Parse(Request["installments"]),
        PaymentMethodId = Request["paymentMethodId"],
        Payer = new PaymentPayerRequest
        {
            Email = Request["cardholderEmail"],
            Identification = new IdentificationRequest
            {
                Type = Request["identificationType"],
                Number = Request["identificationNumber"],
            },
            FirstName = Request["cardholderName"]
        },
    };

    var client = new PaymentClient();
    Payment payment = await client.CreateAsync(paymentRequest);

    Console.WriteLine(payment.Status);
    `,
    type: 'csharp',
    extension: 'cs',
    value: 'csharp',
    payment: 'card',
    name: 'C Sharp',
  },
  {
    code: `
    using MercadoPago.Config;
    using MercadoPago.Client.Common;
    using MercadoPago.Client.Payment;
    using MercadoPago.Resource.Payment;

    MercadoPagoConfig.AccessToken = "ENV_ACCESS_TOKEN";

    var request = new PaymentCreateRequest
    {
        TransactionAmount = 105,
        Description = "Título do produto",
        PaymentMethodId = "pix",
        Payer = new PaymentPayerRequest
        {
            Email = "test@test.com",
            FirstName = "Test",
            LastName = "User",
            Identification = new IdentificationRequest
            {
                Type = "CPF",
                Number = "191191191-00",
            },
        },
    };

    var client = new PaymentClient();
    Payment payment = await client.CreateAsync(request);
    `,
    type: 'csharp',
    extension: 'cs',
    value: 'csharp',
    payment: 'bankTransfer',
    name: 'C Sharp',
  },
  {
    code: `
      using MercadoPago.Config;
      using MercadoPago.Client.Common;
      using MercadoPago.Client.Payment;
      using MercadoPago.Resource.Payment;

      MercadoPagoConfig.AccessToken = "ENV_ACCESS_TOKEN";

      var request = new PaymentCreateRequest
      {
          TransactionAmount = 105,
          Description = "Título do produto",
          PaymentMethodId = "bolbradesco",
          Payer = new PaymentPayerRequest
          {
              Email = "test@test.com",
              FirstName = "Test",
              LastName = "User",
              Identification = new IdentificationRequest
              {
                  Type = "CPF",
                  Number = "191191191-00",
              },
          },
      };

      var client = new PaymentClient();
      Payment payment = await client.CreateAsync(request);
    `,
    type: 'csharp',
    extension: 'cs',
    value: 'csharp',
    payment: 'ticket',
    name: 'C Sharp',
  },
  {
    code: `
    import mercadopago
    sdk = mercadopago.SDK("ACCESS_TOKEN")

    payment_data = {
        "transaction_amount": float(request.POST.get("transaction_amount")),
        "token": request.POST.get("token"),
        "description": request.POST.get("description"),
        "installments": int(request.POST.get("installments")),
        "payment_method_id": request.POST.get("payment_method_id"),
        "payer": {
            "email": request.POST.get("cardholderEmail"),
            "identification": {
                "type": request.POST.get("identificationType"),
                "number": request.POST.get("identificationNumber")
            }
            "first_name": request.POST.get("cardholderName")
        }
    }

    payment_response = sdk.payment().create(payment_data)
    payment = payment_response["response"]

    print(payment)
    `,
    type: 'python',
    extension: 'py',
    value: 'python',
    payment: 'card',
    name: 'Python',
  },
  {
    code: `

    import mercadopago
    sdk = mercadopago.SDK("ENV_ACCESS_TOKEN")

    payment_data = {
        "transaction_amount": 100,
        "description": "Título do produto",
        "payment_method_id": "pix",
        "payer": {
            "email": "test@test.com",
            "first_name": "Test",
            "last_name": "User",
            "identification": {
                "type": "CPF",
                "number": "191191191-00"
            },
            "address": {
                "zip_code": "06233-200",
                "street_name": "Av. das Nações Unidas",
                "street_number": "3003",
                "neighborhood": "Bonfim",
                "city": "Osasco",
                "federal_unit": "SP"
            }
        }
    }

    payment_response = sdk.payment().create(payment_data)
    payment = payment_response["response"]
    `,
    type: 'python',
    extension: 'py',
    value: 'python',
    payment: 'bankTransfer',
    name: 'Python',
  },
  {
    code: `
      import mercadopago
      sdk = mercadopago.SDK("ENV_ACCESS_TOKEN")

      payment_data = {
          "transaction_amount": 100,
          "description": "Título do produto",
          "payment_method_id": "bolbradesco",
          "payer": {
              "email": "test@test.com",
              "first_name": "Test",
              "last_name": "User",
              "identification": {
                  "type": "CPF",
                  "number": "191191191-00"
              },
              "address": {
                  "zip_code": "06233-200",
                  "street_name": "Av. das Nações Unidas",
                  "street_number": "3003",
                  "neighborhood": "Bonfim",
                  "city": "Osasco",
                  "federal_unit": "SP"
              }
          }
      }

      payment_response = sdk.payment().create(payment_data)
      payment = payment_response["response"]
    `,
    type: 'python',
    extension: 'py',
    value: 'python',
    payment: 'ticket',
    name: 'Python',
  },
  {
    code: `
    curl -X POST \
    -H 'accept: application/json' \
    -H 'content-type: application/json' \
    -H 'Authorization: Bearer YOUR_ACCESS_TOKEN' \
    'https://api.mercadopago.com/v1/payments' \
    -d '{
          "transaction_amount": 100,
          "token": "ff8080814c11e237014c1ff593b57b4d",
          "description": "Blue shirt",
          "installments": 1,
          "payment_method_id": "visa",
          "issuer_id": 310,
          "payer": {
            "email": "PAYER_EMAIL_HERE",
            "identification": {
                "number": 19119119100,
                "type": "CPF"
            }
          }
    }'
    `,
    type: 'curl',
    extension: 'txt',
    value: 'curl',
    payment: 'card',
    name: 'Curl',
  },
  {
    code: `
    curl -X POST \
    -H 'accept: application/json' \
    -H 'content-type: application/json' \
    -H 'Authorization: Bearer ENV_ACCESS_TOKEN' \
    'https://api.mercadopago.com/v1/payments' \
    -d '{
      "transaction_amount": 100,
      "description": "Título do produto",
      "payment_method_id": "pix",
      "payer": {
        "email": "PAYER_EMAIL_HERE",
        "first_name": "Test",
        "last_name": "User",
        "identification": {
            "type": "CPF",
            "number": "19119119100"
        },
        "address": {
            "zip_code": "06233200",
            "street_name": "Av. das Nações Unidas",
            "street_number": "3003",
            "neighborhood": "Bonfim",
            "city": "Osasco",
            "federal_unit": "SP"
        }
      }
    }'
    `,
    type: 'curl',
    extension: 'txt',
    value: 'curl',
    payment: 'bankTransfer',
    name: 'Curl',
  },
  {
    code: `
      curl -X POST \
      -H 'accept: application/json' \
      -H 'content-type: application/json' \
      -H 'Authorization: Bearer ENV_ACCESS_TOKEN' \
      'https://api.mercadopago.com/v1/payments' \
      -d '{
        "transaction_amount": 100,
        "description": "Título do produto",
        "payment_method_id": "bolbradesco",
        "payer": {
          "email": "PAYER_EMAIL_HERE",
          "first_name": "Test",
          "last_name": "User",
          "identification": {
              "type": "CPF",
              "number": "19119119100"
          },
          "address": {
              "zip_code": "06233200",
              "street_name": "Av. das Nações Unidas",
              "street_number": "3003",
              "neighborhood": "Bonfim",
              "city": "Osasco",
              "federal_unit": "SP"
          }
        }
      }'
    `,
    type: 'curl',
    extension: 'txt',
    value: 'curl',
    payment: 'ticket',
    name: 'Curl',
  },
];

module.exports = componentCodeBack;
